import { createCompletionServiceSelector } from '../../../features/tracking/services/CompletionService';
import { StudentThunkDispatch } from '../../../types/redux';
import { StudentStore } from '../../models/Store';
import { getItemByIdSelector } from '../../reducers/items/itemsSelectors';
import { trackingCompleted } from '../../reducers/student/tracking/completionTrackingActions';
import { CourseCompletionStatus, TrackingClient, TrackingData, TrackingDataVersion } from './clients/trackingClient';
import { TrackingCompletionService } from './trackingCompletionService';

export const persistTrackingChange = async (
  getState: () => StudentStore,
  trackingClient: TrackingClient
): Promise<void> => {
  const state = getState();
  const trackingData: TrackingData = {
    finishedItems: state.tracking.items.finishedItems,
    widgetTrackingData: state.tracking.questionWidget.previouslySelectedOptionsForItems,
    openQuestionAnswers: state.tracking.openQuestionAnswers.answers,
    version: TrackingDataVersion.v2,
  };
  try {
    await trackingClient.setTrackingData(trackingData);
  } catch (err) {
    console.error('persistTrackingChange failed', err);
  }
};

export const maybeMarkCourseComplete = async (
  dispatch: StudentThunkDispatch,
  getState: () => StudentStore,
  trackingClient: TrackingClient
): Promise<void> => {
  const state = getState();
  const trackedItems = state.tracking.items.trackedItems;
  if (trackedItems.size === 0) {
    return;
  }

  const completionService = createCompletionServiceSelector(state);
  const getItemById = getItemByIdSelector(state);
  const trackingCompletionService = new TrackingCompletionService(getItemById, completionService);

  if (!trackingCompletionService.areAllItemsCompleted(trackedItems)) {
    return;
  }

  dispatch(trackingCompleted());
  try {
    await trackingClient.setCompletionStatus(CourseCompletionStatus.Completed);
  } catch (err) {
    console.error('maybeMarkCourseComplete failed', err);
  }
};

export const persistQuizStatus = async (
  getState: () => StudentStore,
  trackingClient: TrackingClient
): Promise<void> => {
  const { trackedQuiz } = getState().tracking;
  if (trackedQuiz.passed === null || trackedQuiz.score === null) {
    return;
  }
  try {
    await trackingClient.setQuizStatus({ passed: trackedQuiz.passed, score: trackedQuiz.score });
  } catch (err) {
    console.error('persistQuizStatus failed', err);
  }
};
